import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';
import { connect } from 'react-redux';
import DisplayConnectionTable from './DisplayConnectionTable';
import LoadingComponent from '../../../../adminpanel/components/commonComponents/LoadingComponent';

const DataConnector = ({ history, authData }) => {

    const [tableData, setTableData] = useState([]);
    const [displayTable, setdisplayTable] = useState(false);

    useEffect(() => {
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            companyName: authData.companyName
        }
        getConnectorData(params);
    }, [])

    const getConnectorData = (params) => {
        CallAPI('get', '/app/get_database_connector', null, params, 0, function (response) {
            if (response.status === true) {
                let sampleData = []
                response.information.map(function (elementData) {
                    elementData = decodePassword(elementData)
                    elementData = elementData ? JSON.parse(elementData) : []
                    var temp = elementData
                    let summaryConnection = JSON.parse(elementData.summary_connection)
                    temp.successCount = summaryConnection.Success
                    temp.failedCount = summaryConnection.Fail;
                    let connectionDetails = (elementData.connection_details)
                    connectionDetails = connectionDetails ? JSON.parse(connectionDetails) : []
                    connectionDetails['dbpassword'] = connectionDetails.dbpassword
                    temp['connection_details'] = JSON.stringify(connectionDetails)
                    sampleData.push(temp)
                })
                response['information'] = sampleData
                setTableData(response.information);
                setdisplayTable(true);
            } else {
                setTableData([]);
                setdisplayTable(true);
            }
        }, authData)
    }

    const updateRecord = (row) => {
        let params = {
            siteId: authData.siteId,
            companyName: authData.companyName
        }
        let encodedRowData = row
        // let encodedRowData = encodePostBody(row)
        CallAPI('post', '/app/update_database_connector', encodedRowData, params, 0, function (response) {
            if (response.information[0].status) {
                alert(response.information[0].information)
                getConnectorData(params)
            } else alert(response.error_message[0].information)
        }, authData)
    }

    const handleSave = (inputValue, rowNumber, data, columnName) => {
        let checkValidity = true
        checkValidity = checkValidity ? (checkSpecialChars(inputValue) ? false : true) : false
        if (checkValidity === false) {
            alert('Please enter valid input!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
        } else {
            data[columnName] = inputValue;
            data['rockmetric_update'] = true;
            data['rockmetric_update_columns'] = [columnName]
            updateRecord([data])
        }
    }

    let displayData = <h5 className="text-center mg-t-100">
        No Connections Exists <br />
        <Link to="/adminpanel/v2/initialize_connector">Click Here</Link> To Add New Connection
    </h5>
    if (displayTable && tableData.length > 0) {
        displayData = <DisplayConnectionTable tableData={tableData} setTableData={handleSave} updateRecord={updateRecord} />
    }

    return (
        <>
            {displayTable ? displayData : <LoadingComponent />}
        </>
    );
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
}

export default connect(mapStateToProps, null)(DataConnector);